import React from 'react';
const IconFormCheckSquare = () => {
  return (<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M3 21H21V3H3V21ZM17.71 9.71L11 16.41L6.79 12.21L8.21 10.79L11 13.59L16.29 8.29L17.71 9.71Z" fill="#2D2E2E"/>
</svg>
);
};
export default IconFormCheckSquare;